export function hasCriterionAwardToday(progress, criterionId) {
  return criterionId != null && (progress?.todayUsedCriteriaIds || [])
    .some((id) => String(id) === String(criterionId));
}
